import { createContext } from "react";
import type { useSurvey } from "@/components/survey/use-survey";

/** Context */
export const SurveyContext = createContext<ReturnType<typeof useSurvey>>(
	{} as ReturnType<typeof useSurvey>,
);
